export class Categoria {
  _id:     string;
  nombre:  string;
  icono:   string;
  area:    string;
}



// WEBPACK FOOTER //
// ./src/dominio/categoria.ts